import React from 'react';
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
  maxValueMonetario,
  minValueMonetario,
  renderFieldCheck,
  renderFieldMonetarioFormulario,
  renderFieldText,
  required,
} from '../../util/inputs';
import {arredondamentoPadrao, realParaNumber} from '../../util/numberUtil';
import adicionarFormasPagamentoEncomenda from '../../actions/encomenda/adicionarFormasPagamentoEncomenda';
import {tamanhoArquivoUpload} from '../../util/applicationContext';
import {showErrorMsg} from '../../util/messagesUtil';
import { VALORCOMBINADO } from './AbaPagamento';

const seletor = formValueSelector('formularioCadastroEncomenda');

export const validate = (values, props) => {  
  const errors = {};
  // Sicoob PIX é exclusivo (desmarca as demais formas) e sempre cobra o valor total
  if (values.sicoob) {
    return errors
  }
  if (values.cartao || values.dinheiro || values.pix) {
    let total;
    if (props.dadosPagamentoEncomenda.tipoCalculo.value === 'VALOR_COMBINADO') {      
      if (props.dadosPagamentoEncomenda.habilitadoSeguro) {
        total = realParaNumber(props.dadosPagamentoEncomenda.valorCombinado) + props.dadosPagamentoEncomenda.valorSeguro;
      } else {
        total = realParaNumber(props.dadosPagamentoEncomenda.valorCombinado)
      }
    } else {      
      if (props.dadosPagamentoEncomenda.habilitadoSeguro) {
        total = realParaNumber(props.dadosPagamentoEncomenda.valorCalculado) + props.dadosPagamentoEncomenda.valorSeguro;
      } else {
        total = realParaNumber(props.dadosPagamentoEncomenda.valorCalculado)
      }
    }
    if (values.cartao && values.pix && values.dinheiro) {
      const valorTotal = arredondamentoPadrao(realParaNumber(values.valorCartao) + realParaNumber(values.valorPIX) + realParaNumber(values.valorDinheiro))
      if (valorTotal > total || valorTotal !== total) {
        errors.valorDinheiro = 'A soma dos valores deve ser igual ao valor total'
        errors.valorCartao = 'A soma dos valores deve ser igual ao valor total'
        errors.valorPIX = 'A soma dos valores deve ser igual ao valor total'
      }
      return errors
    }
    if (values.pix && values.dinheiro) {
      const valorTotal = arredondamentoPadrao(realParaNumber(values.valorPIX) + realParaNumber(values.valorDinheiro))
      if (valorTotal > total || valorTotal !== total) {
        errors.valorDinheiro = 'A soma dos valores deve ser igual ao valor total'
        errors.valorPIX = 'A soma dos valores deve ser igual ao valor total'
      }
      return errors
    }
    if (values.pix && values.cartao) {
      const valorTotal = arredondamentoPadrao(realParaNumber(values.valorPIX) + realParaNumber(values.valorCartao))
      if (valorTotal > total|| valorTotal !== total) {
        errors.valorCartao = 'A soma dos valores deve ser igual ao valor total'
        errors.valorPIX = 'A soma dos valores deve ser igual ao valor total'
      }
      return errors
    }
    if (values.cartao && values.dinheiro) {
      const valorTotal = arredondamentoPadrao(realParaNumber(values.valorCartao) + realParaNumber(values.valorDinheiro))
      if (valorTotal > total || valorTotal !== total) {
        errors.valorDinheiro = 'A soma dos valores deve ser igual ao valor total'
        errors.valorCartao = 'A soma dos valores deve ser igual ao valor total'
      }
      return errors
    }
    if (values.cartao) {
      const valorTotal = realParaNumber(values.valorCartao);
      if (valorTotal !== total) {
        errors.valorCartao = 'Valor deve ser igual ao valor total'
      }
      return errors
    }
    if (values.pix) {
      if (realParaNumber(values.valorPIX) !== total) {
        errors.valorPIX = 'Valor deve ser igual ao valor total'
      }
      return errors
    }
    if (values.dinheiro) {
      const valorTotal = realParaNumber(values.valorDinheiro)
      if (valorTotal !== total) {
        errors.valorDinheiro = 'Valor deve ser igual ao valor total'
      }
      return errors
    }
  }
  return errors
};

export class FormCadastrarFormaPagamentoEncomenda extends React.Component {
  constructor (props) {
    super(props);
  }

  handleChange (event) {
    const file = event.target.files[0];
    if (/\.(jpe?g|png|pdf)$/i.test(file.name) === false) {
      return
    }
    if (file.size > tamanhoArquivoUpload) {
      showErrorMsg('Tamanho do arquivo excede 20 MB');
      return
    }
    this.converterParaBase64(file, 'CARTAO')
  }

  handleChangePix(event) {
    const file = event.target.files[0];
    if (/\.(jpe?g|png|pdf)$/i.test(file.name) === false) {
      return
    }
    this.converterParaBase64(file, 'PIX')
  }

  converterParaBase64(file, formaPagamento) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      if(formaPagamento == 'PIX') {
        this.props.changeFieldValue('formularioCadastroEncomenda',
        'base64ComprovantePIX', reader.result);
      this.props.changeFieldValue('formularioCadastroEncomenda',
        'nomeComprovanteVendaPIX', file.name);
      } else {
        this.props.changeFieldValue('formularioCadastroEncomenda',
        'base64Comprovante', reader.result);
      this.props.changeFieldValue('formularioCadastroEncomenda',
        'nomeComprovanteVenda', file.name);
      }
    }.bind(this);
  }

  limparFormulario () {
    this.props.reset('formularioCadastroEncomenda');
    this.removerArquivo();
  }

  exibirAnexar () {
    if (this.props.base64Comprovante) {
      return (
          <div className="row align-items-center mt-2">
            <div className='col-12 label-cancelamento'>
              <label>Comprovante:</label>
            </div>
            <div className='ml-4'>{this.props.nomeComprovanteVenda}</div>
            {this.exibirRemoverComprovante('CARTAO')}
          </div>)
    }
    return (
      <React.Fragment>
        <div className='input-wrapper mt-3'>
          <label className='btn-laranja' htmlFor='input-file'>
            <div className='row align-items-center'>
              <i className="material-icons aberto">&#xe2c3;</i>
              <strong className='ml-2'>Anexar comprovante de pagamento</strong>
            </div>
          </label>
          <input id='input-file' type='file' value='' accept="image/png,image/jpeg,application/pdf"
                 onChange={this.handleChange.bind(this)}/>
        </div>
        <label style={{ fontSize: 'smaller' }}>
          * Tamanho máximo permitido : 20 MB
        </label>
      </React.Fragment>)
  }

  exibirAnexarPix() {
    if (this.props.base64ComprovantePIX) {
      return (
        <div className="row align-items-center mt-2">
          <div className='col-12 label-cancelamento'>
            <label>Comprovante:</label>
          </div>
          <div className='ml-4'>{this.props.nomeComprovanteVendaPIX}</div>
          {this.exibirRemoverComprovante('PIX')}
        </div>)
    }
    return (
      <div className='input-wrapper mt-3'>
        <label className='btn-laranja' htmlFor='input-file'>
          <div className='row align-items-center'>
            <i className="material-icons aberto">&#xe2c3;</i>
            <strong className='ml-2'>Anexar comprovante de pagamento</strong>
          </div>
        </label>
        <input id='input-file' type='file' value='' accept="image/png,image/jpeg,application/pdf"
          onChange={this.handleChangePix.bind(this)} />
      </div>)
  }

  exibirRemoverComprovante(formaPagamento) {
    return (
      <button type="button" className="btn btn-editar"
        title='Remover'
        onClick={() => this.removerArquivo(formaPagamento)}>
        <i className="material-icons nav-icon" style={{
          color: 'red'
        }}>&#xe14c;</i>
      </button>)
  }

  removerArquivo(formaPagamento) {
    if(formaPagamento == 'PIX') {
      this.props.changeFieldValue('formularioCadastroEncomenda',
      'base64ComprovantePIX', null);
    this.props.changeFieldValue('formularioCadastroEncomenda',
      'nomeComprovanteVendaPIX', null);
    } else {
      this.props.changeFieldValue('formularioCadastroEncomenda',
      'base64Comprovante', null);
    this.props.changeFieldValue('formularioCadastroEncomenda',
      'nomeComprovanteVenda', null);
    }
  }

  valorTotalComSeguro () {
    let valorTotal = this.props.dadosPagamentoEncomenda.tipoCalculo.value == VALORCOMBINADO ? this.props.dadosPagamentoEncomenda.valorCombinado : this.props.dadosPagamentoEncomenda.valorCalculado
    
    if (this.props.dadosPagamentoEncomenda.habilitadoSeguro) {
      valorTotal = realParaNumber(valorTotal) + this.props.dadosPagamentoEncomenda.valorSeguro;      
    }
    return valorTotal;
  }

  handleCheckDinheiro () {
    const dinheiro = !this.props.dinheiro;
    this.props.changeFieldValue('formularioCadastroEncomenda',
      'dinheiro', dinheiro); 
    const valorTotal = this.valorTotalComSeguro();
    
    this.props.changeFieldValue('formularioCadastroEncomenda',
    'valorDinheiro', valorTotal.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }));
    this.desmarcarSicoob();

    this.props.verificarSeFormaPagamentoNaoFoiSelecionado(dinheiro, this.props.cartao, this.props.pix, false);
  }

  handleCkeckCartao () {
    const cartao = !this.props.cartao
    this.props.changeFieldValue('formularioCadastroEncomenda',
      'cartao', cartao);
    this.desmarcarSicoob();

    this.props.verificarSeFormaPagamentoNaoFoiSelecionado(this.props.dinheiro, cartao, this.props.pix, false);
  }

  handleCheckPix() {
    const pix = !this.props.pix;
    this.props.changeFieldValue('formularioCadastroEncomenda',
      'pix', pix);
    this.desmarcarSicoob();

    this.props.verificarSeFormaPagamentoNaoFoiSelecionado(this.props.dinheiro, this.props.cartao, pix, false);
  }

  desmarcarSicoob() {
    this.props.changeFieldValue('formularioCadastroEncomenda', 'sicoob', false);
    this.props.changeFieldValue('formularioCadastroEncomenda', 'valorSicoob', '');
  }

  // Sicoob PIX é exclusivo: o QR Code é gerado após criar a encomenda, sempre pelo valor total
  handleCheckSicoob() {
    const sicoob = !this.props.sicoob;
    this.props.changeFieldValue('formularioCadastroEncomenda', 'sicoob', sicoob);
    if (sicoob) {
      this.props.changeFieldValue('formularioCadastroEncomenda', 'cartao', false);
      this.props.changeFieldValue('formularioCadastroEncomenda', 'dinheiro', false);
      this.props.changeFieldValue('formularioCadastroEncomenda', 'pix', false);
      this.props.changeFieldValue('formularioCadastroEncomenda', 'valorSicoob',
        this.valorTotalComSeguro().toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }));
    } else {
      this.props.changeFieldValue('formularioCadastroEncomenda', 'valorSicoob', '');
    }

    this.props.verificarSeFormaPagamentoNaoFoiSelecionado(!sicoob && this.props.dinheiro, !sicoob && this.props.cartao, !sicoob && this.props.pix, sicoob);
  }

  recuperarValorTotal () {
    if (this.props.dadosPagamentoEncomenda.tipoCalculo.value === 'VALOR_COMBINADO') {
      return realParaNumber(this.props.dadosPagamentoEncomenda.valorCombinado)
    }
    return realParaNumber(this.props.dadosPagamentoEncomenda.valorCalculado)
  }

  render () {
    return (
      <div>
        <div className='d-flex justify-content-center'>
            <form>
            <div className="modal-body">
              <div className="form-check form-check-inline d-flex justify-content-center">
                <Field name="cartao" type="checkbox" component={renderFieldCheck} label="Cartão"                  
                  css="form-check-input" readOnly={false} className="form-check-input"
                  onChange={() => this.handleCkeckCartao()} />

                <Field name="dinheiro" type="checkbox" component={renderFieldCheck} label="Dinheiro"                  
                  css="form-check-input" readOnly={false} className="form-check-input"
                  onChange={() => this.handleCheckDinheiro()} />

                <Field name="pix" type="checkbox" component={renderFieldCheck} label="PIX"                  
                  css="form-check-input" readOnly={false} className="form-check-input"
                  onChange={() => this.handleCheckPix()} />

                {this.props.usuariosEmpresa && this.props.usuariosEmpresa.habilitadoSicoob && (
                  <Field name="sicoob" type="checkbox" component={renderFieldCheck} label="Sicoob PIX"
                    css="form-check-input" readOnly={false} className="form-check-input"
                    onChange={() => this.handleCheckSicoob()} />
                )}
              </div>
              <div className="d-flex justify-content-center">
                <div>
                  <div className="form-row">
                    {this.props.dinheiro ? <div className="form-group">
                      <Field name="valorDinheiro" type="text" validate={[required, maxValueMonetario, minValueMonetario]} component={renderFieldMonetarioFormulario}                        
                        css="form-control col-md-10" label="Valor em dinheiro" />
                    </div>
                      : ''}
                  </div>
                  {this.props.cartao && <div className="form-row">
                    <h4><strong>Informações pagamento com cartão</strong></h4>
                  </div>}
                  {this.props.cartao ? <div className="form-row">
                    <div className="form-group">
                      <Field name="valorCartao" type="text" validate={[required, maxValueMonetario, minValueMonetario]} component={renderFieldMonetarioFormulario}                        
                        css="form-control col-md-8" label="Valor em cartão" />
                    </div>
                    <div className="form-group">
                      <Field name="numeroComprovante" type="text" component={renderFieldText}                      
                        css="form-control col-md-8" label="Número comprovante:" />
                    </div>
                    
                    <div className="form-group">
                      <Field name="quantidadeParcelas" type="text" component={renderFieldText}
                        label="Quantidade de parcelas:"
                        css="form-control col-md-3" readOnly={false} />
                    </div>

                  </div> : ''}
                  {this.props.cartao && <div className='form-row'>
                    <div className="form-group">
                      {this.exibirAnexar()}
                    </div>
                  </div>}
                  {this.props.pix && <div className="form-row">
                    <h4><strong>Informações pagamento com PIX</strong></h4>
                  </div>}
                  {this.props.pix ? <div className="form-row">
                    <div className="form-group">
                      <Field name="valorPIX" type="text" validate={[required, maxValueMonetario, minValueMonetario]} component={renderFieldMonetarioFormulario}                        
                        css="form-control col-md-8" label="Valor em PIX" />
                    </div>
                    <div className="form-group">
                      <Field name="numeroComprovantePIX" type="text" component={renderFieldText}                      
                        css="form-control col-md-8" label="Número comprovante PIX:" />
                    </div>
                  </div> : ''}
                  {this.props.pix && <div className='form-row'>
                    <div className="form-group">
                      {this.exibirAnexarPix()}
                    </div>
                  </div>}
                  {this.props.sicoob && <div className="form-row">
                    <div className="form-group">
                      <Field name="valorSicoob" type="text" component={renderFieldMonetarioFormulario}
                        css="form-control col-md-8" label="Valor Sicoob PIX" readOnly={true} />
                      <small className="form-text text-muted">
                        O QR Code PIX é gerado após criar a encomenda.
                      </small>
                    </div>
                  </div>}
                </div>
              </div>              
            </div>
            </form>
          </div>
          </div>
    )
  }
}

export function mapStateToProps (state) {
  return {
    dadosPagamentoEncomenda: state.dadosPagamentoEncomenda,
    nomeComprovanteVenda: seletor(state, 'nomeComprovanteVenda'),
    base64Comprovante: seletor(state, 'base64Comprovante'),
    nomeComprovanteVendaPIX: seletor(state, 'nomeComprovanteVendaPIX'),
    numeroComprovantePIX: seletor(state, 'numeroComprovantePIX'),
    base64ComprovantePIX: seletor(state, 'base64ComprovantePIX'),
    dinheiro: seletor(state, 'dinheiro'),
    cartao: seletor(state, 'cartao'),
    pix: seletor(state, 'pix'),
    sicoob: seletor(state, 'sicoob'),
    valorSicoob: seletor(state, 'valorSicoob'),
    usuariosEmpresa: state.usuariosEmpresa,
    valorCartao: seletor(state, 'valorCartao'),
    valorDinheiro: seletor(state, 'valorDinheiro'),
    valorPIX: seletor(state, 'valorPIX'),
    quantidadeParcelas: Number(seletor(state, 'quantidadeParcelas'))
  }
}

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    changeFieldValue,
    adicionarFormasPagamentoEncomenda
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'formularioCadastroEncomenda',
  enableReinitialize: false,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate
})(FormCadastrarFormaPagamentoEncomenda));
